import MoodIcon from '@mui/icons-material/Mood';
import MoodBadIcon from '@mui/icons-material/MoodBad';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import { AgColor } from '../../Styles/AgColor';
import { Box } from '@mui/material';
import { MOOD_TYPE } from '../../../Constants';

const AgMoodItem = ({ mood, selected, onClick }:{mood: MOOD_TYPE; selected?: boolean; onClick?: Function}) => {
  const bgColor = mood === MOOD_TYPE.VeryDissatisfied ? AgColor.orangeMain :
    mood === MOOD_TYPE.Dissatisfied ? AgColor.orangeLight :
      mood ===  MOOD_TYPE.Satisfied ? AgColor.greenLight :
        AgColor.greenMain;

  return (
    <Box
      onClick={()=>onClick && onClick()}
      sx={{
        bgcolor: bgColor,
        width: '120px',
        height: '72px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '8px',
        border: selected ? `4px solid ${AgColor.secondaryMain}` : '4px solid transparent',
        cursor: 'pointer',
        ':hover': {
          border: `4px solid ${AgColor.secondaryLight}`,
        }
      }}
    >
      {
        mood === MOOD_TYPE.VeryDissatisfied?
          <MoodBadIcon sx={{ width: '40px', height: '40px', color: AgColor.grey9 }}/> :
          mood === MOOD_TYPE.Dissatisfied ?
            <SentimentVeryDissatisfiedIcon sx={{ width: '40px', height: '40px', color: AgColor.grey9 }}/> :
            mood === MOOD_TYPE.Satisfied ? 
              <SentimentSatisfiedAltIcon sx={{ width: '40px', height: '40px', color: AgColor.grey9 }}/> :
              <MoodIcon sx={{ width: '40px', height: '40px', color: AgColor.grey9 }}/>
      }
    </Box>
  );
};

export default AgMoodItem;